<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class="blkm">
                   <img src="./image/banner@2x.png" style="position:absolute;width: 100%;height: 100%"></img>
                </div>
                <div @click="goBack" class="imgp"><van-icon name="arrow-left" /></div>
                <div class="tit">工程师信息</div>
                <div class="blku">
                    <div class="engSty">
                        <div class="ltxt"><span class="txt1">{{estItem.name}}</span>--<span class="txt2">{{estItem.group==0?'机动组':'驻场组'}}</span></div>
                        <div class="blkf">
                             <div class="blkp"></div>
                             <div style="display:flex">
                                 <div class="txti">单位</div>
                             </div>
                             <div class="blkn">
                                 <div class="txtj">{{estItem.companyName}}</div>
                              </div>
                         </div>
                         <div class="blkf">
                              <div class="blkp"></div>
                              <div style="display:flex">
                                  <div class="txti">驻点单位</div>
                              </div>
                              <div class="blkn">
                                  <div class="txtj">{{estItem.pointCompanyName}}</div>
                               </div>
                          </div>
                           <div class="blkf">
                                <div class="blkp"></div>
                                <div style="display:flex">
                                    <div class="txti">手机号码</div>
                                </div>
                                <div class="blkn">
                                    <div class="txtj">{{estItem.tel}}</div>
                                 </div>
                            </div>

                    </div>
					<div class="engSty2">
						<img src="./image/engineer@2x.png" style="width:100%;height:100%"/>
						<div class="eng2txt">江苏淮工深蓝信息技术有限公司<br>提供技术支持</div>
					</div>
                </div>
                <div class="blky">
					<img :src="headImg" class="imgy"  v-if="headImg"></img>
                    <img src="./image/Avatar1@2x.png" class="imgy" v-else></img>
					<div class="gRects"></div>
                </div>
            </div>
        </div>
     </div>


</template>
<script>
    import PJXQ from '@/components/pjxq.vue'
    export default{
        components:{PJXQ},
        data(){
            return {
                estItem:[],
				headImg:null
            }
        },
        created(){
            this.getEngData()
        },
        methods:{
            toresponseDetail(){
                this.$router.push('/responseDetail')
            },
            toautograph(){
                this.$router.push('/autograph')
            },
            goBack(){
                this.$router.push('/mine')
            },
            getEngData(){
                let data={engineerId:this.$route.query.engineerId};
                this.$api.get('/app/engineer/getEngineerInfoById',{params:data}).then(res=>{
                       if(res.data.code=="0000"){
                            this.estItem=res.data.data;
							if(this.estItem.headImg){
								// this.headImg='http://180.100.77.186:9085/prod-yh'+this.estItem.headImg
								// this.headImg='http://180.100.77.186:9085/prod-yh'+this.estItem.headImg
								this.headImg=process.env.VUE_APP_IMG_URL+this.estItem.headImg
							}
                       }
                    }
                )
            },
        }
    }
</script>
<style scoped>
     .wrap{
        position: absolute;
        top: 0;
        left:0;
        width:100%;
        height:100%;
        overflow: auto;
		overflow-x:hidden;
        background:#e9eef2;
        z-index:1000;
    }
    .wrap_inner{
         min-height: 100%;
         width:100%;
    }
    .wrap_main{
        position:relative;
        padding-bottom: 50px;
    }
    .engSty{
        width: 309px;
        height: 220px;
        padding:80px 12px 18px 12px;
        margin:20px auto;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
	.engSty2{
	    width: 255px;
	    height: 105px;
	    margin:20px auto;
	    border-radius: 4px;
	    font-size:12px;
	}
    .blkm{
    	position:relative;width: 100%;height: 200px;
    }
    .blku{
        position:absolute;top:142px;left:0;right:0;bottom:0;
    }
	.gRects{
		position:absolute;
		bottom:15px;
		right:44px;
		z-index:2002;
		width:18px;
		height:18px;
		border-radius:12px;
		background:#09F175;
	}
    .blky{
        position:absolute;
        top:82px;
        left:50%;
		transform:translate(-50%,0);
        width:144px;
        height:144px;
        padding:18px;
        border-radius:180px;
        background:#fff;
    }
    .imgy{
		position:absolute;
        width:144px;
        height:144px;
        z-index:2000;
        border-radius:144px;
    }
    .imgp{
        position:absolute;
        display:flex;
        align-items:center;
        justify-content:center;
        top:10px;
        left:14px;
        width:10px;
        height:14px;
        color:#fff;
        font-size:25px;
    }
    .tit{
        position:absolute;
        top:35px;
        left:0;
        width:100%;
        height:28px;
        text-align:center;
        color:#fff;
        font-size:20px;
        font-weight:800;
    }
    .txtu{
    	flex:1;text-align:right;font-size: 13px;font-weight: 400;color: #333333;
    }
    .txtj{
    	flex:1;text-align:left;font-size: 13px;font-weight: 400;color: #333333;
    }
    .txtr{
    	flex:1;text-align:right;font-size: 12px;font-weight: 400;color: #333333;
    }
    .txti{
    	flex:1;text-align:left;font-size: 12px;font-weight: 400;color: #333333;
    }
    .blkn{
    	display:flex;height:22px;margin-top:8px;
    }
    .blkp{
    	position:absolute;top:10px;left:0;width: 4px;height: 13px;background: #1aaeff;
    }
    .blkf{
    	position:relative;margin:0 auto;padding:8px 13px;background:#fff;border-bottom:1px solid #f2f2f2
    }
    .ltxt{
        width:250px;
        height:20px;
        margin-left:121px;
		margin-top:18px;
    }
    .txt1{
        font-size:14px;
        font-weight:700;
        color:#333;
        line-height:6px
    }
    .txt2{
        font-size:12px;
        font-weight:500;
        color:#333;
        line-height:20px;
    }
	.eng2txt{
		font-size: 14px;
		line-height:20px;
		font-weight: 700;
		margin-top:10px;
		text-align: center;
		color: #999999;
	}

</style>
